import { Link } from "react-router-dom";
import {
  Sparkles,
  HandHeart,
  Leaf,
  Sun,
  MessagesSquare,
  Calendar,
  UserCircle,
  Pin,
  Settings,
  Inbox,
  Users,
} from "lucide-react";

// Central registry of editable sections. Add new entries here to expose them in admin.
export const SITE_SECTIONS = [
  {
    group: "Ana sayfa",
    items: [
      { key: "hero", label: "Açılış (Hero)", icon: Sparkles,
        path: "/admin/icerik/hero", description: "En üstteki büyük başlık ve alt metin." },
      { key: "value_1", label: "Değer kartı — 1", icon: HandHeart,
        path: "/admin/icerik/value_1", description: "Sol değer kartı (varsayılan: Saygıyla karşılamak)" },
      { key: "value_2", label: "Değer kartı — 2", icon: Leaf,
        path: "/admin/icerik/value_2", description: "Orta değer kartı (varsayılan: Sevgi içinde büyütmek)" },
      { key: "value_3", label: "Değer kartı — 3", icon: Sun,
        path: "/admin/icerik/value_3", description: "Sağ değer kartı (varsayılan: Özgürlük içinde bırakmak)" },
      { key: "feature_forum", label: "Özellik satırı — Tartışmalar", icon: MessagesSquare,
        path: "/admin/icerik/feature_forum", description: "Başlık, açıklama ve buton metni.", hasCta: true },
      { key: "feature_events", label: "Özellik satırı — Etkinlikler", icon: Calendar,
        path: "/admin/icerik/feature_events", description: "Başlık, açıklama ve buton metni.", hasCta: true },
      { key: "feature_profile", label: "Özellik satırı — Profil", icon: UserCircle,
        path: "/admin/icerik/feature_profile", description: "Başlık, açıklama ve buton metni.", hasCta: true },
    ],
  },
  {
    group: "Sayfalar",
    items: [
      { key: "about", label: "Hakkımızda", icon: Leaf, path: "/admin/hakkimizda",
        description: "Hakkımızda sayfasının başlığı ve gövde metni." },
      { key: "forum_rules", label: "Topluluk kuralları", icon: Pin, path: "/admin/kurallar",
        description: "Tartışmalar sayfasının en üstünde sabit gönderi." },
    ],
  },
  {
    group: "Yönetim",
    items: [
      { key: "users", label: "Üyeler", icon: Users, path: "/admin/uyeler",
        description: "Tüm üyeleri gör, ara ve CSV olarak dışa aktar." },
      { key: "categories", label: "Tartışma kategorileri", icon: MessagesSquare, path: "/admin/kategoriler",
        description: "Kategori isim ve açıklamaları." },
      { key: "inquiries", label: "Ürün talepleri", icon: Inbox, path: "/admin/talepler",
        description: "Mağazadan gelen ilgi bildirimlerini yönet." },
    ],
  },
];

export default function AdminSiteSettings() {
  return (
    <div className="k-container py-12 md:py-16">
      <div className="flex items-center gap-3">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-earth-400/20 text-earth-500">
          <Settings className="h-6 w-6" />
        </span>
        <div>
          <h1 className="font-display text-5xl text-ink-900" data-testid="site-settings-title">
            Site Ayarları
          </h1>
          <p className="font-body text-ink-700">Sitedeki tüm düzenlenebilir bölümler tek yerde.</p>
        </div>
      </div>

      <div className="mt-10 space-y-10">
        {SITE_SECTIONS.map((group) => (
          <section key={group.group}>
            <h2 className="font-heading text-lg font-bold uppercase tracking-widest text-ink-500">
              {group.group}
            </h2>
            <div className="mt-4 grid gap-4 md:grid-cols-2">
              {group.items.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.key}
                    to={item.path}
                    className="k-card group flex items-start gap-4 p-6 transition-all hover:-translate-y-0.5 hover:shadow-warm"
                    data-testid={`settings-link-${item.key}`}
                  >
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-sage-500/15 text-sage-700">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div className="min-w-0">
                      <h3 className="font-heading text-lg font-bold text-ink-900 group-hover:text-sage-700 transition-colors">
                        {item.label}
                      </h3>
                      <p className="mt-1 font-body text-sm text-ink-700">{item.description}</p>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
